import { useMemo } from 'react';
import type { StatsScore, StatsTask } from 'src/common/interfaces/manage-room';
export const useGetTransformedStats = (userStats: StatsScore[] = []) => {
  const stats = useMemo(() => {
    const transformedStatsData = [];
    let csvData = [];
    for (const taskNo of Object.keys((userStats?.[0] as StatsScore)?.tasks ?? {})) {
      for (const question of (userStats?.[0] as StatsScore).tasks[taskNo] as StatsTask[]) {
        const title = `T${taskNo}Q${question.questionNo}`;
        csvData.push(title);
      }
    }
    csvData = [['Rank', 'Username', ...csvData, 'Score']];
    for (const userStat of userStats) {
      const {
        rank,
        username,
        avatar,
        score,
        tasks = {}
      } = userStat;
      const questions: string[] = [];
      let totalCorrect = 0;
      let totalIncorrect = 0;
      for (const taskNo of Object.keys(tasks)) {
        for (const question of tasks[taskNo] as StatsTask[]) {
          if (question.correct) {
            totalCorrect++;
            questions.push('Correct');
          } else {
            totalIncorrect++;
            questions.push('Incorrect');
          }
        }
      }
      const totalQuestions = totalCorrect + totalIncorrect;
      const questionCompleteText = `${totalCorrect}/${totalQuestions}`;
      transformedStatsData.push({
        rank,
        username,
        avatar,
        score,
        questionCompleteText
      });
      csvData.push([rank.toString(), username, ...questions, score.toString()]);
    }
    return {
      transformedStatsData,
      csvData
    };
  }, [userStats]);
  const {
    transformedStatsData,
    csvData
  } = stats;
  return {
    transformedStatsData,
    csvData
  };
};